import { useParams } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import FormConstatNew from "../../components/forms/FormConstatNew/FormConstatNew";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import {
  useFetchConstatGravitiesQuery,
  useFetchConstatQuery,
  useFetchSitesQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";
import { isDev } from "../../utils/dev";
import styles from "../PageConstat/PageConstat.module.scss";

const PageConstatEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { data: constatData, isFetching } = useFetchConstatQuery(Number(id), {
    skip: !id,
  });

  const { data: sitesData, isFetching: isFetchingSites } = useFetchSitesQuery();
  const { data: pilotes } = useFetchUsersForFieldQuery("pilote");
  const { data: admins } = useFetchUsersForFieldQuery("sdlp-superadmin");
  const { data: constatGravitiesData } = useFetchConstatGravitiesQuery();

  if (isDev) {
    console.log("constatData", constatData);
    console.log("sitesData", sitesData);
  }

  const isPageLoading = isFetching || isFetchingSites;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Breadcrumbs
        pageName="constat"
        constatId={constatData?.id}
        constatName={constatData?.name}
      />
      {isPageLoading && <h1>Loading..</h1>}
      {!!constatData && (
        <FormConstatNew
          sites={sitesData?.results}
          isEditMode
          constat={constatData}
          pilotes={pilotes}
          admins={admins}
          constatGravities={constatGravitiesData?.results}
        />
      )}
    </PageLayout>
  );
};

export default PageConstatEdit;
